import React from "react";
import RadioActive from "../../../../../../assets/icon/RadioActive";
import Radio from "../../../../../../assets/icon/Radio";

type Props = {
  isMetadataActive?: boolean;
  isRadioActice?: boolean;
  onClick?: () => void;
};

const EfirControl: React.FC<Props> = ({ isMetadataActive, isRadioActice }) => {
  return (
    <>
      {isMetadataActive && isRadioActice ? (
        <div className="flex items-center pt-1.5">
          <RadioActive />
          <span className="text-[13px] font-semibold pl-2 text-green">
            Зараз в ефірі
          </span>
        </div>
      ) : (
        <div className="flex items-center pt-1.5">
          <Radio />
          <span className="pl-2 text-[13px] font-semibold opacity-60">До ефіру</span>
        </div>
      )}
    </>
  );
};

export default EfirControl;
